<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
  <button mat-icon-button (click)="scrollToTop()" matTooltip="Back to the top!" aria-label="Button that takes you to the top of the page">
    <i class="fas fa-chevron-up"></i>
  </button>
</div>